import { render, staticRenderFns } from "./CommonFacialDeviceUserTable.vue?vue&type=template&id=f96d4802&scoped=true&"
import script from "./CommonFacialDeviceUserTable.vue?vue&type=script&lang=js&"
export * from "./CommonFacialDeviceUserTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f96d4802",
  null
  
)

export default component.exports